import React from "react";

// Campus Form Modal Component
function CampusFormModal({
  isOpen,
  isEdit,
  formData,
  principals = [],
  onFormChange,
  onSubmit,
  onClose,
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{isEdit ? "Edit Campus" : "Add New Campus"}</h3>
          <button type="button" className="modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <form onSubmit={onSubmit}>
            <div className="reg-form-group">
              <label className="reg-form-label">Campus Name *</label>
              <input
                type="text"
                className="reg-input"
                name="name"
                value={formData.name}
                onChange={onFormChange}
                required
                placeholder="Enter campus name"
              />
            </div>
            <div className="reg-form-group">
              <label className="reg-form-label">Location</label>
              <input
                type="text"
                className="reg-input"
                name="location"
                value={formData.location}
                onChange={onFormChange}
                placeholder="Enter location"
              />
            </div>
            <div className="reg-form-group">
              <label className="reg-form-label">Principal</label>
              <select
                className="reg-input"
                name="principal"
                value={formData.principal || ""}
                onChange={onFormChange}
              >
                <option value="">Select a principal</option>
                {principals.map((principal) => (
                  <option
                    key={principal.id ?? principal.username}
                    value={principal.username}
                  >
                    {principal.username}
                  </option>
                ))}
              </select>
            </div>
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="btn-primary">
                {isEdit ? "Update Campus" : "Create Campus"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CampusFormModal;
